import type { FaireProductEntity } from "../../entity_types/product";

export const p_ymmah7saug: FaireProductEntity = {
  token: "p_ymmah7saug",
  type: "product",
  name: "Indonesia Bali Natural",
  brandToken: "b_f358njub53",
  brandName: "Comeback",
  imageUrl: "https://cdn.faire.com/fastly/57cfb8542d059dfdba04eb01237c4934e84aa3c4380ef190923ed976f70c6ce1.jpeg",
  galleryImageUrls: [],
  priceDollars: 35,
  description: "Tasting Notes\n\nBlueberry• Orange Blossom • Barley\n\nAs always, flavor is subjective. We just hope you enjoy.\n",
  tags: [],
  msrpDollars: 49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:19.313Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
